import moment from "moment";

export const getRequestPriority = (type) => {
  switch (type) {
    case 0:
      return "Low";
    case 1:
      return "Moderate";
    case 2:
      return "High";
    default:
      return "";
  }
};

export const setRequestPriority = (type) => {
  switch (type) {
    case "Low":
      return 0;
    case "Moderate":
      return 1;
    case "High":
      return 2;
    default:
      return 0;
  }
};

export const getRequestStatus = (type) => {
  switch (type) {
    case "In Progress":
      return 0;
    case "Monitoring":
      return 1;
    case "Slipping":
      return 2;
    case "Completed":
      return 3;
    case "On Hold":
      return 4;
    default:
      return 0;
  }
};

export const updateCapacity = (array1, array2) => {
  return array1.map((item1) => {
    const matchedItem = array2.find((item2) => item2.id === item1.resource.id);
    if (matchedItem) {
      return {
        ...item1,
        approvedCapacity: matchedItem.allocatedEffort,
      };
    } else {
      return {
        ...item1,
        approvedCapacity: 0,
      };
    }
  });
};

// ─── Dependency date-shift helpers  ─────

// Returns the next working day (Mon–Fri) after the given ISO date string.
export const nextWorkingDayAfter = (dateStr) => {
  const d = moment(dateStr, "YYYY-MM-DD").add(1, "day");
  // Snap Saturday→Monday, Sunday→Monday
  if (d.day() === 6) d.add(2, "days");
  else if (d.day() === 0) d.add(1, "day");
  return d.format("YYYY-MM-DD");
};

// Calendar-day difference (to − from), both ISO date strings.
export const calendarDaysDiff = (fromStr, toStr) => {
  return moment(toStr, "YYYY-MM-DD").diff(moment(fromStr, "YYYY-MM-DD"), "days");
};

// Shift an ISO date string by N calendar days.
export const shiftDateStr = (dateStr, days) => {
  return moment(dateStr, "YYYY-MM-DD").add(days, "days").format("YYYY-MM-DD");
};
// ─────────────────────────────────────────────────────────────────────────────

export const searchScopeHandler = (
  value,
  projectId,
  scopeService,
  setScopes
) => {
  const payload = {
    projectId: projectId,
    value,
  };
  scopeService
    .searchScopeRequest(payload)
    .then((res) => {
      const transformedArray = res.map((obj) => ({
        label: obj.name,
        value: obj.id,
      }));
      setScopes(transformedArray);
    })
    .catch(() => {
      setScopes([]);
    });
};
